import { useEffect } from "react";
import FilterValueProps from "types/FilterValueProps";

interface useToggleSelectAllProps{
    options: Array<FilterValueProps>
    selectedOptions : Array<FilterValueProps>
    setAllItemsSelected: Function
}

const useToggleSelectAll = (props: useToggleSelectAllProps) => {
useEffect(() => {
      props.setAllItemsSelected(props.options?.length === props.selectedOptions?.length)
  }, [props.options, props.selectedOptions]);
}


export default useToggleSelectAll 